import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { loginGetData } from "../../store/actions/loginActions";
import Login from "./Login";

const LoginContainer = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const getResourceData = () => {
    dispatch(loginGetData());
    let path = "dashboard";
    history.push(path);
  };

  return <Login getResourceData={getResourceData} />;
};

export default LoginContainer;
